import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useLocation} from 'react-router-dom';
import IconCard from '../../mainPage/subcomponent/MBBeVoIconCard/MBBeVoIconCard';
import {CATEGORY_PROPS} from '../../../globals/Constants';

/**
 * Main page (landing page or home page) component.
 *
 * @returns
 */

export function Category() {
    const {i18n} = useTranslation();
    const location = useLocation();
    useEffect(() => {
        // Change language based on the current pathname
        const path = location.pathname; // Get the current pathname
        if (path.startsWith('/de') || path === '/de') {
            i18n.changeLanguage('de');
        } else if (path.startsWith('/en') || path === '/en') {
            i18n.changeLanguage('en');
        }

        // Scroll to top on component mount
        window.scrollTo(0, 0);
    }, [location.pathname, i18n]); // Add location.pathname and i18n as dependencies
    return (
        <>
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px'}}>
                {CATEGORY_PROPS.map(function (element, index) {
                    return (
                        <IconCard props={element} key={index}></IconCard>
                    );
                })}
            </div>
        </>
    );
}
